import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { ModalButton } from 'src/components/Global/Button/Button'
import { TargetImg } from 'src/assets'
import { ContentWrapper, TargetOnboardingWrapper } from './style'
import { OnboardingText } from 'src/components/Global/Text/TitleText'

const TargetOnboarding = () => {
  let location = useLocation()
  return (
    <TargetOnboardingWrapper>
      <ContentWrapper>
        <div className="content_img">
          <img src={TargetImg} alt="" />
        </div>
        <div className="content_text">
          <p className="tribe">Save with your tribe</p>
          <div className="title">
            <OnboardingText> Target Savings</OnboardingText>
          </div>
          <div className="description">
            <p>
              Save towards a specific date or amount. This plan is strict so
              that you can hit your savings goal.
            </p>
          </div>
        </div>
      </ContentWrapper>
      <div className="onboarding_btn">
        <Link to={`/target-name`} state={{ backgroundLocation: location }}>
          <ModalButton className="button">Get Started</ModalButton>
        </Link>
      </div>
      {/* </form> */}
    </TargetOnboardingWrapper>
  )
}

export { TargetOnboarding }
